import { MYLOADS_TABS } from "../Constants/Constants";
import { fbLogEvent } from "../Helpers/FirebaseHelper";
import { EVENT, SCREEN } from "../Constants/AnalyticsConstants";

export const getLoads = (selectedSlug: string, myLoadsData: any): any => {
    switch (selectedSlug) {
        case MYLOADS_TABS.DRIVER_ASSIGNED:
            return myLoadsData?.driverAssignedShipments || [];
        case MYLOADS_TABS.IN_TRANSIT:
            return myLoadsData?.inTransitShipments || [];
        case MYLOADS_TABS.DELIVERED:
            return myLoadsData?.deliveredShipments || [];
    }
    return null;
}

export const getLoadCount = (selectedSlug: string, myLoadsData: any): number => {
    switch (selectedSlug) {
        case MYLOADS_TABS.DRIVER_ASSIGNED:
            return myLoadsData?.driverAssignedCount || 0;
        case MYLOADS_TABS.IN_TRANSIT:
            return myLoadsData?.inTransitCount || 0;
        case MYLOADS_TABS.DELIVERED:
            return myLoadsData?.deliveredCount || 0;
    }
    return 0;
}

export const sendFBLogEvent = (selectedSlug: string) => {
    switch (selectedSlug) {
        case MYLOADS_TABS.DRIVER_ASSIGNED:
            fbLogEvent(EVENT.SV_VIEW_DRIVER_ASSIGNED, {
                screen: SCREEN.MYLOADS_DRIVER_ASSIGNED,
            });
            break;
        case MYLOADS_TABS.IN_TRANSIT:
            fbLogEvent(EVENT.SV_VIEW_IN_TRANSIT, {
                screen: SCREEN.MYLOADS_IN_TRANSIT,
            });
            break;

        case MYLOADS_TABS.DELIVERED:
            fbLogEvent(EVENT.SV_VIEW_MYLOADS, {
                screen: SCREEN.MYLOADS,
            });
            break;
    }
}

